import React, { Component } from 'react';
import {
  Button,
} from 'react-bootstrap';
// icons
import IconPlus from 'react-icons/lib/go/plus';
// stores
import UserStore from '../../stores/UserStore';
// components
import PaymentDialog from '../../components/Payment/PaymentDialog';
import Loading from '../../components/Shared/Loading';
// models
import CreditCardOwnerInfo from '../../models/CreditCardOwnerInfo';
// css
import './Buttons.css';

class AddPaymentMethodButton extends Component {
  constructor(props) {
    super(props);
    this.creditCardOwnerInfo = new CreditCardOwnerInfo();

    const stripeSource = UserStore.user.stripeSource;
    this.state = {
      showDialog: false,
      ready: !!UserStore.user.stripeCustomerId,
      addingPayment: stripeSource && stripeSource.isCreateStripeSourceRequest,
    };
  }

  componentDidMount() {
    if (!UserStore.user.stripeCustomerId) {
      UserStore.waitFor("stripeCustomerId").then(() => {
        this.setState({ ready: true });
      });
    }
  }

  render() {
    const {
      showDialog,
      ready,
      addingPayment
    } = this.state;

    if (addingPayment && !showDialog) {
      return (<Loading text="" />);
    }

    return (
      <Button
        bsStyle="success"
        onClick={() => this.showDialog(true)}
        disabled={!ready}>
        {ready ? <span><IconPlus /> Payment method</span> : "Loading..."}
        <PaymentDialog
          show={showDialog}
          creditCardOwnerInfo={this.creditCardOwnerInfo}
          addingPayment={addingPayment}
          onSave={this.onPaymentDialogSave}
          onCancel={() => this.showDialog(false)} />
      </Button>
    );
  }

  showDialog = (bShow = false) => {
    this.setState({ showDialog: bShow });
  }

  onPaymentDialogSave = (token) => {
    this.setState({ addingPayment: true });
    if (token) {
      UserStore.addPaymentMethod(token)
      .then(stripeSource => {
        this.setState({
          addingPayment: false,
          showDialog: false,
        });
        const onSave = this.props.onSave;
        if (onSave) {
          onSave(stripeSource)
        }
      })
      .catch((e) => {
        this.setState({ addingPayment: false });
        alert(e.message);
      });
    }
  }

}

export default AddPaymentMethodButton;


// WEBPACK FOOTER //
// ./src/components/Buttons/AddPaymentMethod.js